import React, {FC} from "react";
import {Tag, Button} from "antd";
import {FilterOutlined} from "@ant-design/icons";
import formatDate from "../../helpers/formatDate";
import styles from "./assistantApp.less";

interface AssistantFilterBarProps {
    onOpenDrawer: () => void;
    selectedCity?: string;
    onClearCity: () => void;
    selectedLocationId?: string;
    selectedLocationLabel?: string;
    onClearLocation: () => void;
    selectedMonth: Date | null;
    onClearMonth: () => void;
    hasAssignedLocations: boolean;
}

const AssistantFilterBar: FC<AssistantFilterBarProps> = ({
    onOpenDrawer,
    selectedCity,
    onClearCity,
    selectedLocationId,
    selectedLocationLabel,
    onClearLocation,
    selectedMonth,
    onClearMonth,
    hasAssignedLocations,
}) => {
    return (
        <div className={styles.assistantFilterBar}>
            <Button
                className={styles.assistantFilterButton}
                icon={<FilterOutlined />}
                onClick={onOpenDrawer}
                size="small"
            >
                {"Filter"}
            </Button>
            {hasAssignedLocations ? (
                <Tag className={styles.assistantFilterTag} color="blue">
                    {"Meine Standorte"}
                </Tag>
            ) : null}
            {selectedMonth ? (
                <Tag closable onClose={onClearMonth} className={styles.assistantFilterTag}>
                    {formatDate(selectedMonth, "MMM yyyy")}
                </Tag>
            ) : null}
            {selectedCity ? (
                <Tag closable onClose={onClearCity} className={styles.assistantFilterTag}>
                    {selectedCity}
                </Tag>
            ) : null}
            {selectedLocationId && selectedLocationLabel ? (
                <Tag closable onClose={onClearLocation} className={styles.assistantFilterTag}>
                    {selectedLocationLabel}
                </Tag>
            ) : null}
        </div>
    );
};

export default AssistantFilterBar;
